import { useIdleLogout } from '../hooks/useIdleLogout';

const SessionManager = ({ children }) => {
  useIdleLogout(5 * 60 * 1000); // 3 minutes
  return children;
};

export default SessionManager;
